module.exports = __webpack_public_path__ + "video/700_SERF_2022_PhishingAttacks.1880fe69.vtt";